import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#1976d2',
            light: '#4791db',
            dark: '#115293',
            contrastText: '#ffffff'
        },
        secondary: {
            main: '#d97706',
            contrastText: '#ffffff'
        },
        success: { main: '#16a34a' },
        warning: { main: '#d97706' },
        error: { main: '#dc2626' },
        background: {
            default: '#f5f7fa',
            paper: '#ffffff'
        },
        divider: 'rgba(0,0,0,0.08)',
        text: {
            primary: 'rgba(0,0,0,0.87)',
            secondary: 'rgba(0,0,0,0.6)'
        }
    },
    shape: {
        borderRadius: 8
    },
    typography: {
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            'Segoe UI',
            'Roboto',
            'sans-serif'
        ].join(','),
        button: { textTransform: 'none' }
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    backgroundColor: '#f5f7fa',
                    minHeight: '100vh'
                },
                '*::-webkit-scrollbar': { width: 10, height: 10 },
                '*::-webkit-scrollbar-thumb': { background: 'rgba(0,0,0,0.18)', borderRadius: 8 },
                '*::-webkit-scrollbar-thumb:hover': { background: 'rgba(0,0,0,0.28)' }
            }
        },
        MuiPaper: {
            defaultProps: { elevation: 0 },
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                    backgroundColor: '#ffffff',
                    border: '1px solid rgba(0,0,0,0.08)'
                }
            }
        },
        MuiAppBar: {
            defaultProps: { elevation: 0, color: 'inherit' },
            styleOverrides: {
                root: {
                    backgroundColor: '#ffffff',
                    borderBottom: '1px solid rgba(0,0,0,0.08)'
                }
            }
        },
        MuiButton: {
            defaultProps: { disableElevation: true },
            styleOverrides: {
                root: { borderRadius: 6 }
            }
        },
        MuiChip: {
            styleOverrides: {
                root: { borderRadius: 6 },
                outlined: { borderColor: 'rgba(0,0,0,0.16)' }
            }
        },
        MuiTableCell: {
            styleOverrides: {
                head: {
                    fontWeight: 600,
                    color: 'rgba(0,0,0,0.6)',
                    borderBottom: '1px solid rgba(0,0,0,0.08)'
                },
                body: {
                    borderBottom: '1px solid rgba(0,0,0,0.06)'
                }
            }
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    '&:hover': { backgroundColor: 'rgba(0,0,0,0.03)' }
                }
            }
        },
        MuiTextField: {
            defaultProps: { variant: 'outlined', size: 'small' }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    backgroundColor: '#ffffff'
                }
            }
        },
        MuiAutocomplete: {
            defaultProps: { fullWidth: true },
            styleOverrides: {
                root: { width: '100%' },
                inputRoot: { flexWrap: 'nowrap' },
                input: {
                    minWidth: '0 !important',
                    flex: '1 1 auto !important'
                }
            }
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: 10,
                    border: '1px solid rgba(0,0,0,0.08)'
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    backgroundColor: '#1f2937',
                    color: '#ffffff',
                    fontSize: 12,
                    padding: '6px 8px'
                }
            }
        }
    }
});

export default theme;
